import React, { useState, useRef } from 'react'
import Header from '../../components/generals/header'
import DataTableLazyApps from '../../components/generals/datatables/dataTableLazyApps'
import { Toast } from 'primereact/toast'
import store from '../../reducer/store'
import styles from '../../css/applications/Apps.module.css'
import stylesIndex from './../../css/Index.module.css'
import { putData } from '../../actions/servicesHttp'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import ToggleButton from 'react-bootstrap/ToggleButton'
import { Dropdown } from 'primereact/dropdown'
import MostUsedApps from '../../components/generals/MostUsedApps'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function Applications () {
  const { t } = useTranslation('applications')
  const toast = useRef(null)
  const { user } = store.getState()
  const navigate = useNavigate()
  const role = user.roles

  //* estados de componentes
  const [reload, setReload] = useState(false)
  const [category, setCategory] = useState(9)
  const [editCategories, setEditCategories] = useState(false)
  const [dateFilter, setDateFilter] = useState(0)
  const [historic, setHistoric] = useState(false)

  // Filtro de fecha
  const dates = [
    { name: t('dateFilter.label1'), value: 1 },
    { name: t('dateFilter.label2'), value: 7 },
    { name: t('dateFilter.label3'), value: 31 }
  ]

  // Categorias
  const categories = [
    { name: t('category1'), id: 0 },
    { name: t('category2'), id: 1 },
    { name: t('category3'), id: 2 },
    { name: t('category4'), id: 3 },
    { name: t('category5'), id: 4 },
    { name: t('category6'), id: 5 },
    { name: t('category7'), id: 6 },
    { name: t('category8'), id: 7 },
    { name: t('category9'), id: 8 },
    { name: t('category10'), id: 9 }
  ]

  // aplicaciones por actualizar
  const appsToPut = []

  const getApp = async (data) => {
    let appFound
    const app = data

    if (appsToPut.length === 0) {
      appsToPut.push(app)
    } else {
      appFound = appsToPut.find((item) => item.id === app.id)
      if (appFound === undefined) {
        appsToPut.push(app)
      } else {
        appsToPut.forEach((item) =>
          item.id === appFound.id ? (item.groupApp = app.groupApp) : null
        )
      }
    }
  }

  const getCategory = (value) => {
    switch (value) {
      case t('category1'):
        return 0
      case t('category2'):
        return 1
      case t('category3'):
        return 2
      case t('category4'):
        return 3
      case t('category5'):
        return 4
      case t('category6'):
        return 5
      case t('category7'):
        return 6
      case t('category8'):
        return 7
      default:
        return null
    }
  }

  const showToast = (type, value, message) => {
    toast.current.show({
      severity: type,
      summary: value,
      detail: message,
      life: 3000
    })
  }

  const putApps = async (data) => {
    let response
    if (data.length === 0) {
      showToast('info', t('message5'), t('message1'))
      return
    } else {
      data.forEach(element => {
        element.groupApp = element.groupApp === t('message2') ? null : getCategory(element.groupApp)
      })

      response = await putData('applications', data, navigate)

      if (response.status === 200) {
        setReload(true)
        showToast('success', t('message6'), t('message3'))
      } else {
        showToast('error', t('message7'), t('message4'))
      }
    }

    data = []
  }

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <Toast
          ref={toast}
          className={styles.toast}
        />
        <div className={styles.filterContainer}>
          <div className={styles.filterByCategories}>
            <p className={styles.floatLabel}>{t('label1')}</p>
            <Dropdown
              disabled={editCategories}
              value={category}
              options={categories}
              onChange={(e) => {
                console.log(e)
                setCategory(e.value)
              }}
              optionLabel="name"
              optionValue="id"
              placeholder={t('placeholder1')}
              className={styles.dropdown}
            />
          </div>
          <div className={styles.btnsContainer}>
            <ButtonGroup className={styles.dateFilterContainer}>
              {dates.map((date, index) => (
                <ToggleButton
                  key={index}
                  id={`date-${index}`}
                  type="radio"
                  variant="secondary"
                  name="date"
                  disabled={editCategories}
                  value={date.value}
                  checked={date.value === dateFilter}
                  className={styles.btnDateUseTimeApps}
                  onChange={(e) => {
                    setDateFilter(parseInt(e.target.value))
                    setHistoric(false)
                  }}
                >
                  {date.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
            <ToggleButton
              key={'date-historic'}
              id={'date-historic'}
              type="radio"
              variant="secondary"
              name="date-historic"
              disabled={editCategories}
              value={historic}
              checked={historic}
              className={`${styles.btnDateHistoric} ${styles.tooltip}`}
              onChange={() => {
                setHistoric(!historic)
                setDateFilter(0)
              }}
            >
              <i className={`fa-solid fa-clock-rotate-left ${styles}`} />
              <span className={styles.tooltipText}>{t('button1')}</span>
            </ToggleButton>
          </div>
        </div>
        <MostUsedApps
          category={category}
          dateFilter={dateFilter}
          editCategories={editCategories}
        />
        <DataTableLazyApps
          table="apps"
          editCategories={editCategories}
          setEditCategories={setEditCategories}
          category={category}
          putApps={putApps}
          appsToPut={appsToPut}
          getApp={getApp}
          getCategory={getCategory}
          reload={reload}
          setReload={setReload}
          categories={categories}
          dateFilter={dateFilter}
          editCategoryApplication={role?.applicationsPage.editCategoryApplication}
          exportsCsv={false}
          exportsPdf={false}
        />
      </div>
    </div>
  )
}
